export const isOperator = (role) => {
    return role==='Operator';    
}